// extracted by mini-css-extract-plugin
export default {"ArrowLink":"ArrowLink_ArrowLink__Yys7V"};